import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import 'core-js/fn/object/assign';
import 'core-js/fn/array/from';
import { __, sprintf } from '@wordpress/i18n';
import classnames from 'classnames';
import { Component, createRef } from '@wordpress/element';
import { DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import { partial } from 'lodash';
import PropTypes from 'prop-types';
import { withViewportMatch } from '@wordpress/viewport';
/**
 * WooCommerce dependencies
 */

import { validateDateInputForRange } from '@woocommerce/date';
/**
 * Internal dependencies
 */

import DateInput from './input';
import phrases from './phrases';

var isRTL = function isRTL() {
  return document.documentElement.dir === 'rtl';
}; // Blur event sources


var CONTAINER_DIV = 'container';
var NEXT_MONTH_CLICK = 'onNextMonthClick';
var PREV_MONTH_CLICK = 'onPrevMonthClick';
/**
 * This is wrapper for a [react-dates](https://github.com/airbnb/react-dates) powered calendar.
 */

var DateRange =
/*#__PURE__*/
function (_Component) {
  _inherits(DateRange, _Component);

  function DateRange(props) {
    var _this;

    _classCallCheck(this, DateRange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRange).call(this, props));
    _this.onDatesChange = _this.onDatesChange.bind(_assertThisInitialized(_this));
    _this.onFocusChange = _this.onFocusChange.bind(_assertThisInitialized(_this));
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.nodeRef = createRef();
    _this.keepFocusInside = _this.keepFocusInside.bind(_assertThisInitialized(_this));
    return _this;
  }
  /*
   * Todo: We should remove this function when possible.
   * It is kept because focus is lost when we click on the previous and next
   * month buttons or clicking on a date in the calendar.
   * This focus loss closes the date picker popover.
   * Ideally we should add an upstream commit on react-dates to fix this issue.
   *
   * See: https://github.com/WordPress/gutenberg/pull/17201.
   */


  _createClass(DateRange, [{
    key: "keepFocusInside",
    value: function keepFocusInside(blurSource, e) {
      if (!this.nodeRef.current) {
        return;
      }

      var losesFocusTo = this.props.losesFocusTo; // Blur triggered internal to the DayPicker component.

      if (CONTAINER_DIV === blurSource && e.target && (e.target.classList.contains('DayPickerNavigation_button') || e.target.classList.contains('CalendarDay')) && ( // Allow other DayPicker elements to take focus.
      !e.relatedTarget || !e.relatedTarget.classList.contains('DayPickerNavigation_button') && !e.relatedTarget.classList.contains('CalendarDay'))) {
        // Allow other DayPicker elements to take focus.
        if (e.relatedTarget && (e.relatedTarget.classList.contains('DayPickerNavigation_button') || e.relatedTarget.classList.contains('CalendarDay'))) {
          return;
        } // Allow elements inside a specified ref to take focus.


        if (e.relatedTarget && losesFocusTo && losesFocusTo.contains(e.relatedTarget)) {
          return;
        } // DayPickerNavigation or CalendarDay mouseUp() is blurring,
        // so switch focus to the DayPicker's focus region.


        var focusRegion = this.nodeRef.current.querySelector('.DayPicker_focusRegion');

        if (focusRegion) {
          focusRegion.focus();
        }

        return;
      } // Blur triggered after next/prev click callback props.


      if (PREV_MONTH_CLICK === blurSource || NEXT_MONTH_CLICK === blurSource) {
        // DayPicker's updateStateAfterMonthTransition() is about to blur
        // the activeElement, so focus a DayPickerNavigation button so the next
        // blur event gets fixed by the above logic path.
        var _focusRegion = this.nodeRef.current.querySelector('.DayPickerNavigation_button');

        if (_focusRegion) {
          _focusRegion.focus();
        }

        return;
      }
    }
  }, {
    key: "onDatesChange",
    value: function onDatesChange(_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var _this$props = this.props,
          onUpdate = _this$props.onUpdate,
          shortDateFormat = _this$props.shortDateFormat;
      onUpdate({
        after: startDate,
        before: endDate,
        afterText: startDate ? startDate.format(shortDateFormat) : '',
        beforeText: endDate ? endDate.format(shortDateFormat) : '',
        afterError: null,
        beforeError: null
      });
    }
  }, {
    key: "onFocusChange",
    value: function onFocusChange(focusedInput) {
      this.props.onUpdate({
        focusedInput: !focusedInput ? 'startDate' : focusedInput
      });
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(input, event) {
      var _this$props$onUpdate;

      var value = event.target.value;
      var _this$props2 = this.props,
          after = _this$props2.after,
          before = _this$props2.before,
          shortDateFormat = _this$props2.shortDateFormat;

      var _validateDateInputFor = validateDateInputForRange(input, value, before, after, shortDateFormat),
          date = _validateDateInputFor.date,
          error = _validateDateInputFor.error;

      this.props.onUpdate((_this$props$onUpdate = {}, _defineProperty(_this$props$onUpdate, input, date), _defineProperty(_this$props$onUpdate, input + 'Text', value), _defineProperty(_this$props$onUpdate, input + 'Error', value.length > 0 ? error : null), _this$props$onUpdate));
    }
  }, {
    key: "setTnitialVisibleMonth",
    value: function setTnitialVisibleMonth(isDoubleCalendar, before) {
      return function () {
        var visibleDate = before || moment();

        if (isDoubleCalendar) {
          return visibleDate.clone().subtract(1, 'month');
        }

        return visibleDate;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          after = _this$props3.after,
          before = _this$props3.before,
          focusedInput = _this$props3.focusedInput,
          afterText = _this$props3.afterText,
          beforeText = _this$props3.beforeText,
          afterError = _this$props3.afterError,
          beforeError = _this$props3.beforeError,
          shortDateFormat = _this$props3.shortDateFormat,
          isViewportMobile = _this$props3.isViewportMobile,
          isViewportSmall = _this$props3.isViewportSmall,
          isInvalidDate = _this$props3.isInvalidDate;
      var isDoubleCalendar = isViewportMobile && !isViewportSmall;
      return createElement("div", {
        className: classnames('woocommerce-calendar', {
          'is-mobile': isViewportMobile
        })
      }, createElement("div", {
        className: "woocommerce-calendar__inputs"
      }, createElement(DateInput, {
        value: afterText,
        onChange: partial(this.onInputChange, 'after'),
        dateFormat: shortDateFormat,
        label: __('Start Date', 'woocommerce-admin'),
        error: afterError,
        describedBy: sprintf(__("Date input describing a selected date range's start date in format %s", 'woocommerce-admin'), shortDateFormat),
        onFocus: function onFocus() {
          return _this2.onFocusChange('startDate');
        }
      }), createElement("div", {
        className: "woocommerce-calendar__inputs-to"
      }, __('to', 'woocommerce-admin')), createElement(DateInput, {
        value: beforeText,
        onChange: partial(this.onInputChange, 'before'),
        dateFormat: shortDateFormat,
        label: __('End Date', 'woocommerce-admin'),
        error: beforeError,
        describedBy: sprintf(__("Date input describing a selected date range's end date in format %s", 'woocommerce-admin'), shortDateFormat),
        onFocus: function onFocus() {
          return _this2.onFocusChange('endDate');
        }
      })), createElement("div", {
        className: "woocommerce-calendar__react-dates",
        ref: this.nodeRef,
        onBlur: partial(this.keepFocusInside, CONTAINER_DIV),
        tabIndex: -1
      }, createElement(DayPickerRangeController, {
        onNextMonthClick: partial(this.keepFocusInside, NEXT_MONTH_CLICK),
        onPrevMonthClick: partial(this.keepFocusInside, PREV_MONTH_CLICK),
        onDatesChange: this.onDatesChange,
        onFocusChange: this.onFocusChange,
        focusedInput: focusedInput,
        startDate: after,
        endDate: before,
        orientation: 'horizontal',
        numberOfMonths: isDoubleCalendar ? 2 : 1,
        isOutsideRange: function isOutsideRange(date) {
          return isInvalidDate && isInvalidDate(date.toDate());
        },
        minimumNights: 0,
        hideKeyboardShortcutsPanel: true,
        noBorder: true,
        isRTL: isRTL(),
        initialVisibleMonth: this.setTnitialVisibleMonth(isDoubleCalendar, before),
        phrases: phrases
      })));
    }
  }]);

  return DateRange;
}(Component);

DateRange.propTypes = {
  /**
   * A moment date object representing the selected start. `null` for no selection.
   */
  after: PropTypes.object,

  /**
   * A string error message, shown to the user.
   */
  afterError: PropTypes.string,

  /**
   * The start date in human-readable format. Displayed in the text input.
   */
  afterText: PropTypes.string,

  /**
   * A moment date object representing the selected end. `null` for no selection.
   */
  before: PropTypes.object,

  /**
   * A string error message, shown to the user.
   */
  beforeError: PropTypes.string,

  /**
   * The end date in human-readable format. Displayed in the text input.
   */
  beforeText: PropTypes.string,

  /**
   * String identifying which is the currently focused input (start or end).
   */
  focusedInput: PropTypes.string,

  /**
   * A function to determine if a day on the calendar is not valid
   */
  isInvalidDate: PropTypes.func,

  /**
   * A function called upon selection of a date.
   */
  onUpdate: PropTypes.func.isRequired,

  /**
   * The date format in moment.js-style tokens.
   */
  shortDateFormat: PropTypes.string.isRequired,

  /**
   * A ref that the DateRange can lose focus to.
   * See: https://github.com/woocommerce/woocommerce-admin/pull/2929.
   */
  losesFocusTo: PropTypes.instanceOf(Element)
};
export default withViewportMatch({
  isViewportMobile: '< medium',
  isViewportSmall: '< small'
})(DateRange);
//# sourceMappingURL=date-range.js.map